import Vue from "vue";
import { seriesApi } from "@/api";
import { PlanLimitError } from "@/utils/errors";

export default {
  state: () => ({
    seriesList: {},
    recommendations: [],
    genres: [],
  }),

  getters: {
    seriesList: (state) => state.seriesList,
    recommendations: (state) => state.recommendations,
    genres: (state) => state.genres,
  },

  mutations: {
    setSeriesList(state, seriesList) {
      state.seriesList = seriesList.reduce(
        (map, series) => Object.assign(map, { [series.id]: series }),
        {},
      );
    },
    setSeriesRecord(state, series) {
      Vue.set(state.seriesList, series.id, series);
    },
    setRecommendations(state, list) {
      state.recommendations = list;
    },
    setGenres(state, list) {
      state.genres = list;
    },
    unsetSeriesRecord(state, seriesId) {
      Vue.delete(state.seriesList, seriesId);
    },
  },

  actions: {
    fetchAll({ commit }) {
      return seriesApi.fetchAll().then((series) => {
        commit("setSeriesList", series);
      });
    },

    search(_ctx, series) {
      return seriesApi.search(series).then((response) => response);
    },

    fetchRecommendations({ commit }, genreId = null) {
      return seriesApi.recommendations(genreId).then((list) => {
        commit("setRecommendations", list);
        return list;
      });
    },

    fetchGenres({ commit }) {
      return seriesApi.genres().then((list) => {
        commit("setGenres", list);
        return list;
      });
    },

    /**
     * Start tracking a series.
     *
     * Guarded here rather than in each button so every entry point (Explore,
     * recommendation cards, anything added later) enforces the plan limit.
     */
    track({ commit, getters }, seriesId) {
      if (!getters.canTrackMore) {
        return Promise.reject(new PlanLimitError());
      }
      return seriesApi.track(seriesId).then(
        (series) => {
          commit("setSeriesRecord", series);
          return series;
        },
        (error) => {
          // The API enforces the same rule. If our local count was stale
          // (another tab, another device), surface its refusal as a plan
          // limit rather than a generic failure.
          if (error?.response?.data?.code === "plan_limit") {
            throw new PlanLimitError();
          }
          throw error;
        },
      );
    },

    untrack({ commit }, seriesId) {
      return seriesApi.untrack(seriesId).then(() => {
        commit("unsetSeriesRecord", seriesId);
      });
    },

    vote(_ctx, { seriesId, vote }) {
      return seriesApi.vote(seriesId, vote);
    },
  },
};
